var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-carddraw"},[_c('div',{staticClass:"card-list"},_vm._l((_vm.mValue.num),function(index){return _c('div',{key:index,class:{ item: true, shake: _vm.active == index },on:{"click":function($event){return _vm.onStart(index)}}},[_vm._t("item",null,{"item":_vm.mValue.bg || _vm.defaultBg})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }